import CableReady from 'cable_ready'
import consumer from "./consumer"

consumer.subscriptions.create("AlertsChannel", {
  connected() {
  },

  disconnected() {
  },

  received(data) {
    if (data.cableReady) {
      CableReady.perform(data.operations)
    }
  }
});

document.addEventListener('toast:show', function (event) {
  var { type, title, text, duration } = event.detail
  var options = duration ? { timeOut: duration } : { timeOut: 0, extendedTimeOut: 0 }
  toastr[type](text, title, options)
})